module.exports = __webpack_public_path__ + "img/gallery_2.6fd61952.jpg";